// extracted by mini-css-extract-plugin
export default {"language":"CategorySection_language__rWfFK","rightcol":"CategorySection_rightcol__6vLZQ"};